/*eslint no-console: 0*/

import AppPanel from '../../fw/AppPanel.react';
import React from 'react';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, IntlShape} from 'react-intl';
import types from '../../../common/model-api/types';
import InvokeChannelJobMutation from '../InvokeChannelJobMutation.react';
import {wrapNotFound} from '../../app/NotFoundHandler.react';
import "../channel.scss";
import ChannelHeader from '../ChannelHeader.react';
import channelViewParent from '../channelViewParent.react';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import LoadingButton from '../../fw/LoadingButton.react';
import EditorSaver from '../../fw/EditorSaver';
import {createChannelFromChannelDef} from '../ChannelAddStep1.react';
import meQuery from '../../queries/MeQuery';
import RemovedChannelView from './companySearchViewChannelEl.react';
import deepCopy from 'deep-copy';
import {sendToExtension} from '../../app/ExtensionCommunicate';
import urlMapping from '../../app/URLMapping';
import ScenarioBoxAsWizard from '../../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../../scenarios/ScenarioIcon.react';
import ScenarioWizard from '../../scenarios/ScenarioWizard.react';
import StatusIcon from '../../view/box/StatusIcon.react';
import config from '../../../common/config';
import {getLastOrganisationId} from '../../app/LastOrganisationId';

import '../../layout.scss';
import './companySearch.scss';
import '../../scenarios/Scenario.scss';
import {safeJSONparse} from "../../../common/util/safeJSONparse";

class CompanySearch extends channelViewParent {

	constructor(props) {
		super(props);

		let selectedChannels = [];
		let removedChannels = [];
		let forcedChannels = []; // channels to be added by default from scenario applications

		if (props.user.organisation.channel.options) {
			this.options = {...safeJSONparse(props.user.organisation.channel.options), ...safeJSONparse(props.user.organisation.channel.currentUserOptions)};

			if (this.options.channels) {

				// change the array of channel ids to array of objects {channel_id, channelDef_id}
				selectedChannels = this.options.channels.map((channel) => {
					if (typeof channel === 'string') {
						let channelDef = props.user.organisation.companySearchOrgChannels.edges.find(({node}) => {
							return node.realId === channel;
						});
						if (!channelDef) {
							return;
						}
						return {
							channel_id: channel,
							channelDef_id: channelDef.node.channelDef.realId
						};
					}

					return channel;
				}).filter((channel) => {
					return undefined !== channel;
				}).map((channel) => {
					let orgChannel = props.user.organisation.companySearchOrgChannels.edges.find(({node}) => {
						return node.realId === channel.channel_id;
					});

					if (undefined === orgChannel) {
						if (!props.user.organisation.companySearchSystemChannels.edges.find(({node}) => {
							return node.realId === channel.channelDef_id;
						})) {
							removedChannels.push(channel);
						}
					}

					return channel;
				});
			}
		}

		let channelsToBeAdded = [];

		if (props.user.scenario) {
			// As company search is added during scenario definition -> the selectedChannels are presumably empty
			forcedChannels = props.user.scenario.scenarios2ChannelDefs.edges.map(({node}) => {
				return node.channelDef.realId;
			});

			forcedChannels.forEach((forceId) => {
				let forceChannel = props.user.organisation.companySearchOrgChannels.edges.find(({node}) => {
					return node.channelDef.realId === forceId;
				});

				if (forceChannel) {
					selectedChannels.push({
						channel_id: forceChannel.node.realId,
						channelDef_id: forceChannel.node.channelDef.realId
					});
				}
			});

			let existingFullContact = props.user.organisation.companySearchOrgChannels.edges.find(({node}) => {
				return node.channelDef.realId === config.CHANNEL_DEF_FULLCONTACT;
			});

			if (existingFullContact) {
				selectedChannels.push({
					channel_id: existingFullContact.node.realId,
					channelDef_id: existingFullContact.node.channelDef.realId
				});
			}
			else {
				channelsToBeAdded.push(config.CHANNEL_DEF_FULLCONTACT);
			}
		}

		this.state = {
			selectedChannels: selectedChannels,
			channelsToBeAdded: channelsToBeAdded,
			removedChannels: removedChannels,
			forcedChannels: forcedChannels
		};
	}

	addCompaniesByChannelDef() {
        return Promise.all(this.state.channelsToBeAdded.map((channelId) => {
            let channelDefToAdd = this.props.user.organisation.companySearchSystemChannels.edges.find(({node}) => {
                return channelId === node.realId;
            });

            return createChannelFromChannelDef(channelDefToAdd.node, this.props.user.organisation, true).then((channel) => {
				return {
					channel_id: channel.realId,
					channelDef_id: channelDefToAdd.node.realId,
					channel: channel
				};
			});
        }));
    }

	saveChannelOptions(channels) {
		let options = deepCopy(this.options);
		options.channels = channels;

		let channelFatQuery = Relay.QL `fragment on UpdateChannelPayload {
									updatedNode {
										id,
										realId,
										options,
										activated,
									},
								}`;
		let channelMutation = Relay.QL `mutation { updateChannel }`;

		let channel = this.props.user.organisation.channel;
		// eslint-disable-next-line max-params
		let fce = function (data, storeData, defaultValue, columns) {
			storeData['options'] = JSON.stringify(options);
			storeData['id'] = channel['realId'];
			storeData['activated'] = true;

			return storeData;
		};

		let saver = new EditorSaver(types['channels'], channelMutation, channelFatQuery, null, Object.keys(this.options).length > 0 ? EditorSaver.UPDATE : EditorSaver.CREATE, fce);
		return saver.save({});
	}

	onClickSumbit() {
		// TODO editing options in scenario activating

		return new Promise((resolve, reject) => {
			return this.addCompaniesByChannelDef().then((newChannels) => {
				let channelOptions = [...this.state.selectedChannels, ...newChannels];

				return this.saveChannelOptions(channelOptions).then(({updatedNode}) => {
					sendToExtension({
						message: 'dativery-reload',
					});

					if (this.props.createCallback) {
						this.props.createCallback(updatedNode);
					}
					else if (this.props.user.scenario) {
						/* are we creating this channel as part of scenario? */
						let scenarioPrefix = "scenario-";
						let args = {
							id: this.props.user.organisation.channel.realId,
							organisation_id: this.props.user.organisation['realId'],
							scenario_id: this.props.user.scenario['realId']
						};

						let path = urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-3", args);
						this.context.router.push(path);
					}
					else {
						let path = urlMapping.getUrl(types['channels'], "view", {id: this.props.user.organisation.channel.realId, organisation_id: this.props.user.organisation.realId});
						this.context.router.push(path);
					}
				});
			});
		});
	}

	onClickRemove() {
		let channels = this.options.channels.filter((channel) => {
			return !this.state.removedChannels.some((removedChannel) => {
				return removedChannel.channel_id === channel.channel_id;
			});
		});

		return this.saveChannelOptions(channels);
	}

	findselectedChannels(channelId) {
		return this.state.selectedChannels.findIndex((channel) => {
			return channel.channel_id === channelId;
		});
	}

	findChannelToBeAdd(channelDefId) {
		return this.state.channelsToBeAdded.findIndex((channelsToBeAddedId) => {
			return channelsToBeAddedId === channelDefId;
		});
	}

	isChannelSelected(channel, onlyDef) {
		if (onlyDef) {
			return -1 !== this.findChannelToBeAdd(channel.channelDef.realId);
		}

		return -1 !== this.findselectedChannels(channel.realId);
	}

	changeApplicationSelection(channel, onlyDef) {
		let selectedChannels = this.state.selectedChannels;
		let channelsToBeAdded = this.state.channelsToBeAdded;
		let findChannelToBeAddIndex = this.findChannelToBeAdd(channel.channelDef.realId);
		let findselectedChannelsIndex = this.findselectedChannels(channel.realId);

		if (onlyDef) {
			if (findChannelToBeAddIndex === -1) {
				channelsToBeAdded.push(channel.channelDef.realId);
			}
			else {
				channelsToBeAdded.splice(findChannelToBeAddIndex, 1);
			}
		}
		else if (findselectedChannelsIndex === -1) {
			selectedChannels.push({
				channel_id: channel.realId,
				channelDef_id: channel.channelDef.realId
			});
		}
		else {
			selectedChannels.splice(findselectedChannelsIndex, 1);
		}

		this.setState({
			selectedChannels: selectedChannels,
			channelsToBeAdded: channelsToBeAdded
		});
	}

	isChannelForced(channel) {
		return -1 !== this.state.forcedChannels.indexOf(channel.channelDef.realId);
	}

	renderChannel({channel, description, idx, onlyDef}) {
		let isChannelForced = this.isChannelForced(channel);
		return (
			<div className="checkChannel" key={idx}>
				<label disabled={isChannelForced}>
					<div className="applicationLine">
						<input
							checked={this.isChannelSelected(channel, onlyDef)}
							disabled={isChannelForced}
							onChange={() => {
								this.changeApplicationSelection(channel, onlyDef);
							}}
							type="checkbox"
							value={channel.realId}
						/> <ChannelIcon channelDef={channel.channelDef} size={32}/> <span className="title">{this.getName(channel)}</span>
						{
							isChannelForced ?
								(<StatusIcon reactTooltip title={
									<FormattedMessage defaultMessage="Added by default from scenario definition" id="channels.companySearch.defaultAppTooltip" />
								} type={StatusIcon.INFO} />)
								: null
						}
					</div>
					{
						description ?
							(<div className="descriptionLine">{channel.channelDef.description}</div>)
						: null
					}
				</label>
			</div>
		);
	}

	renderOrgChannels() {
		let data = this.props.user.organisation.companySearchOrgChannels;

		return data.edges.filter(({node}) => {
			return !this.props.user.organisation.companySearchSystemChannels.edges.some((sysNode) => {
				return sysNode.node.realId === node.channelDef.realId;
			});
		})
		.sort((nodeA, nodeB) => {
			return this.getName(nodeA.node).localeCompare(this.getName(nodeB.node));
		})
		.map(({node}, idx) => {
			return this.renderChannel({
				channel: node,
				description: true,
				idx: idx
			});
		});
	}

	renderSystemChannels() {
		let data = this.props.user.organisation.companySearchSystemChannels;

		return data.edges
			.sort((nodeA, nodeB) => {
				return nodeA.node.name.localeCompare(nodeB.node.name);
			})
			.map((edgeA, idxA) => {
				let sysNode = edgeA.node;

				let orgChannels = this.props.user.organisation.companySearchOrgChannels.edges.filter(({node}) => {
					return node.channelDef.realId === sysNode.realId;
				}).sort((nodeA, nodeB) => {
					return this.getName(nodeA.node).localeCompare(this.getName(nodeB.node));
				});

				if (orgChannels.length > 0) {
					return orgChannels.map(({node}, idxB) => {
						return this.renderChannel({
							channel: node,
							description: true,
							idx: idxA + '_' + idxB,
						});
					});
				}

				return this.renderChannel({
					channel: {channelDef: sysNode},
					description: true,
					idx: idxA,
					onlyDef: true
				});
			});
	}

	renderRemovedChannels() {
		if (this.state.removedChannels.length === 0) {
			return null;
		}

		return (
			<div className="removedApplications">
				<h4><FormattedMessage defaultMessage="Disconnected applications:" id="channels.companySearch.removedApplications" /></h4>
				<span><FormattedMessage defaultMessage="These applications are disconnected and aren't longer used." id="channels.companySearch.removedApplicationsNote" /></span>
				<div>{
					this.state.removedChannels.map((removedChannel, idx) => {
						const queryConfig = {
							queries: meQuery,
							name: 'User',
							params: {
								channelDefId: removedChannel.channelDef_id
							}
						};

						return (
							<Relay.Renderer
								Container={RemovedChannelView}
								environment={Relay.Store}
								key={idx}
								onReadyStateChange={({aborted, done, error}) => {
									// TODO indicate loading?
								}}
								queryConfig={queryConfig}
							/>
						);
					})
				}</div>
				<LoadingButton className="btn btn-default" href="#" onClick={() => { return this.onClickRemove(); }}>
					<i aria-hidden="true" className="fa fa-fw fa-trash-o"></i> <FormattedMessage defaultMessage="Acknowledge and remove" id="channels.companySearch.removeAction" />
				</LoadingButton>
			</div>
		);
	}

	render() {
		const data = this.props.user.organisation.channel;

		let title = this.getName(data);
		let type = types['channelDefs'];

		let description = <FormattedMessage defaultMessage="Some services needs activation before we can apply this scenario" id="channelWizard.activationDescription" />;
		let wizzardTitle = <FormattedMessage defaultMessage="Scenario activation" id="channelWizard.activationHeader" />;

		let content = (<div>
			<ChannelHeader data={data} organisation={this.props.user.organisation} title={title}>
				{data.channelDef.description ? <p>{data.channelDef.description}</p> : null}
			</ChannelHeader>
			<div className="detailBox">
				<div className="layout-row">
					<div className="flex-50" key={0}>
						<h4 key="-1"><FormattedMessage defaultMessage="Your applications:" id="channels.companySearch.yourApplications2" /></h4>
						<FormattedMessage defaultMessage="Select applications with companies address books which will be searched in:" id="channels.companySearch.yourApplicationsDescription" />
						<div className="channelList">
							{this.renderOrgChannels()}
						</div>
					</div>
					<div className="flex-50" key={1}>
						<h4 key="-1"><FormattedMessage defaultMessage="Searching services:" id="channels.companySearch.searchApplications" /></h4>
						<FormattedMessage defaultMessage="Select search services to have better results:" id="channels.companySearch.searchApplicationsDescription" />
						<div className="channelList">
							{this.renderSystemChannels()}
						</div>
					</div>
				</div>
				<div className="center saveToolbar">
					<LoadingButton className="btn btn-primary" href="#" onClick={() => { return this.onClickSumbit(); }}>
						<i aria-hidden="true" className="fa fa-fw fa-check-circle-o"></i> <FormattedMessage defaultMessage="Save" id="operation.save" />
					</LoadingButton>
					{this.props.cancel ? <button className="btn" onClick={() => { return this.props.cancel();}}><FormattedMessage defaultMessage="Cancel" id="common.cancel" /></button> : null}
				</div>
			</div>
			{this.renderRemovedChannels()}
		</div>);

		if (this.props.wrapper) {
			return content;
		}

		return (
			<AppPanel breadcrumbParams={this.getBreadcrum()} className="ChannelView CompanySearch" title={title}>
				<ScenarioWizard data={this.props.user} description={description} step={1} title={wizzardTitle} type={type}>
					{content}
				</ScenarioWizard>
			</AppPanel>
		);
	}
}

// TODO clear the request fields from unnecessary items
export default Relay.createContainer(wrapNotFound(injectIntl(CompanySearch), (props) => {
	return props.user.organisation && props.user.organisation.channel;
}), {
	initialVariables: {
		organisationId: '',
		channelId: '',
        scenarioId: '',
        scenarioSelected: false,
		timestamp: ''
	},
	prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

		variables['scenarioSelected'] = variables['scenarioId'] ? true : false;

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
                scenario(id: $scenarioId) @include(if: $scenarioSelected) {
                    id,
                    realId,
					urlFragment,
                    ${ScenarioBoxAsWizard.getFragment('scenario')},
                    ${ScenarioIcon.getFragment('scenario')},
	                scenarios2ChannelDefs(first: 100) {
	                    edges {
	                        node {
	                            channelDef {
	                                realId
	                            }
	                        }
	                    }
	                }
                },
				featureFlags,
				organisation(id: $organisationId) {
					id,
					name,
					featureFlags,
					realId,
					${ScenarioBoxAsWizard.getFragment('organisation')},
					channel(id: $channelId) {
						id,
						realId,
						organisation_id,
						type,
						cachingStatus,
						cachingInProgressJob {
							id,
							progress,
							status
						},
						confidential,
						description,
						name,
						lastCachingRefresh,
						metadata,
						options,
						channelDef {
							id,
							name,
							description,
							icon,
							virtual,
							metadata,
							urlFragment,
							usageDataSource,
						},
						${InvokeChannelJobMutation.getFragment('channel')},
					},
					companySearchSystemChannels(first: 100) {
						edges {
							node {
								id,
								realId,
								name,
								description,
								icon,
								virtual,
								metadata,
								urlFragment,
							}
						}
					},
					companySearchOrgChannels(first: 100, timestamp: $timestamp) {
						edges {
							node {
								id,
								realId,
								organisation_id,
								type,
								cachingStatus,
								cachingInProgressJob {
									id,
									progress,
									status
								},
								confidential,
								description,
								name,
								lastCachingRefresh,
								metadata,
								channelDef {
									id,
									realId,
									name,
									description,
									icon,
									virtual,
									metadata,
									urlFragment,
									usageDataSource,
								}
							}
						}
					}
				}
			}
		`,
	},
});
